import React, { useState } from "react";
import EAPageHeader from "../shared/EAPageHeader";
import "./CustomOffer.scss";
import useCustomOffer from "./hooks/useCustomOffer";
import { useTranslation } from "react-i18next";
import EAAlert from "../shared/EAAlert";
import { ProductKinds, SaleStep } from "../../store/stepSaleConfig/stepSaleConfigReducer";
import { getLocalizedStepText } from "../../store/stepSaleConfig/stepSaleConfigUtils";
import PassModule from "./OfferModules/PassModule";
import EventModule from "./OfferModules/EventModule";
import CalendarSaleModule from "./OfferModules/CalendarSaleModule";
import EAPageMessage from "../shared/EAPageMessage";
import ShapeColorAssortGroupModule from "./OfferModules/ShapeColorAssortGroupModule";
import RegisterB2B from "./RegisterB2B";
import SwimmingLessons from "../SwimmingLessons";
import AcademySwimmingRecruitmentModule from "./OfferModules/AcademySwimmingRecruitmentModule";

const CustomOffer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const { customOffer } = useCustomOffer();
  const isRegiterB2B = window.location.href.includes("register-b2b");
  const [isB2BModalOpen, setIsB2BModalOpen] = useState(isRegiterB2B);

  const getModuleByKind = (saleStep: SaleStep) => {
    switch (saleStep.kind) {
      case ProductKinds.Pass:
        return <PassModule key={customOffer?.stepId} saleStep={saleStep} />;
      case ProductKinds.Event:
        return <EventModule key={customOffer?.stepId} saleStep={saleStep} />;
      case ProductKinds.CalendarSale:
        return <CalendarSaleModule key={customOffer?.stepId} saleStep={saleStep} />;
      case ProductKinds.Shape:
      case ProductKinds.Color:
      case ProductKinds.AssortGroup:
        return <ShapeColorAssortGroupModule key={customOffer?.stepId} saleStep={saleStep} />;
      case ProductKinds.AcademySwimmingLessons:
        return <SwimmingLessons key={customOffer?.stepId} saleStep={saleStep} />;
      case ProductKinds.AcademySwimmingRecruitment:
        return <AcademySwimmingRecruitmentModule key={customOffer?.stepId} saleStep={saleStep} />;
    }
  };

  if (!customOffer) {
    return <EAAlert message={t("Nie znaleziono oferty")} type="error" />;
  } else {
    return (
      <>
        <EAPageHeader title={getLocalizedStepText(customOffer.stepName, customOffer.stepName_en, language)} />
        <EAPageMessage
          message={getLocalizedStepText(customOffer.stepDescription, customOffer.stepDescription_en, language)}
        />

        <div className="offer-products-list">
          {customOffer.saleSteps
            .sort((a, b) => a.order - b.order)
            .map((step, index) => (
              <React.Fragment key={index}>{getModuleByKind(step)}</React.Fragment>
            ))}
        </div>

        {isRegiterB2B && <RegisterB2B isOpen={isB2BModalOpen} onClose={() => setIsB2BModalOpen(false)} />}
      </>
    );
  }
};

export default CustomOffer;
